import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import VideocallEnableCheckAlert from './videocallEnableCheckAlert';

describe('Index', () => {
  test('isCaptured', () => {
    render(<VideocallEnableCheckAlert message={"マイクを認識できません。問題がないか確認お願いします"} />);

    // screen.debug();
    expect(screen.getByText('マイクを認識できません。問題がないか確認お願いします')).toBeInTheDocument();
  });
});
